import type { PlayerBonus, PlayerFreespin } from 'api/common';
import type { TFunction } from 'i18next';
import { TooltipTypes } from 'modules/globalTooltip';
import type { GlobalTooltipConfig } from 'modules/globalTooltip/store';
import { BonusReceived } from './BonusReceived';
import { WagerFreeCashReceived } from './WagerFreeCashReceived';

export type TReceivedBonus = PlayerBonus | PlayerFreespin;

export enum EReceivedBonusKind {
  WagerFreeCash = 'wager-free-cash',
  Default = 'default',
}

type TTooltipConfigFactory = (
  bonus: TReceivedBonus,
  t: TFunction
) => GlobalTooltipConfig;

const BASE_CONFIG: Pick<GlobalTooltipConfig, 'id' | 'type'> = {
  id: 'bonus-received',
  type: TooltipTypes.SUCCESS,
};

export const TOOLTIP_CONFIG_BY_KIND: Record<
  EReceivedBonusKind,
  TTooltipConfigFactory
> = {
  [EReceivedBonusKind.WagerFreeCash]: (bonus, t) => {
    const { amountCents, currency } = bonus as PlayerBonus;

    return {
      ...BASE_CONFIG,
      title: t('common:tooltips.wagerFreeCashReceived.title'),
      text: (
        <WagerFreeCashReceived amountCents={amountCents} currency={currency} />
      ),
    };
  },
  [EReceivedBonusKind.Default]: (_, t) => ({
    ...BASE_CONFIG,
    title: t('common:tooltips.bonusReceived.title'),
    text: <BonusReceived />,
  }),
};
